<template lang="pug">
    aside.menu.app-sidebar.overflow-hidden(:class="{ 'hide-sidebar': !showSidebarDesktop && !showSidebarMobile, 'is-mobile': showSidebarMobile }")
      div.menu-label
        span(v-if="!showSidebarDesktop && !showSidebarMobile") SS
        template(v-else)
          .flex.fdc.aic(v-if="pathFoto")
            .avatar.mb-10
              img(:src="pathFoto")
            span.fs-14 Self Service
          span(v-else) Self Service
      transition(name="fade")
        ul.menu-list.overflow-y-scroll(v-if="!isLoadingMenu")
          transition-group.contenedor-sidebar(name="fade-smooth", tag="div")
            li(
              v-for='(item, index) in menu',
              :key="'menu_item_'+index",
              :title="item.name"
            )
              template(v-if="item.path")
                router-link.has-text-left.router-link.ai-center(:to='item.path', :class="!showSidebarDesktop && !showSidebarMobile ? 'router-item' : ''")
                  span.icon.is-small(:class="!showSidebarDesktop && !showSidebarMobile ? 'margin-right-0' : ''")
                    i.fa(:class="item.icon")
                  span.name(v-if="showSidebarDesktop || showSidebarMobile") {{ item.name }}
                  template(v-if="item.key === 'vacaciones'")
                    .badge(v-if="datos.diasVacaciones", :title="datos.diasVacaciones + ' dias por tomar'")
                      span {{ datos.diasVacaciones }}
                  template(v-if="item.key === 'mis-documentos-firmar'")
                    .badge(v-if="documentosPorFirmar", :title="documentosPorFirmar + ' documentos sin firmar'")
                      span {{ documentosPorFirmar }}
                  template(v-if="item.key === 'mis-contratos'")
                    .badge(v-if="contratosPorFirmar", :title="contratosPorFirmar + ' contratos sin firmar'")
                      span {{ contratosPorFirmar }}
                  template(v-if="item.key === 'mis-cursos'")
                    .badge(v-if="cursosSinTerminar", :title="cursosSinTerminar + ' cursos sin terminar'")
                      span {{ cursosSinTerminar }}
                hr.margin-0(v-if="!showSidebarDesktop")
              template(v-else)
                a.has-text-left.ai-center.position-relative(
                  href="#",
                  @click="item.showChildren = !item.showChildren",
                  :class="{ open: item.showChildren, 'router-item' : !showSidebarDesktop && !showSidebarMobile  }"
                )
                  span.icon.is-small(:class="!showSidebarDesktop && !showSidebarMobile ? 'margin-left-20' : ''")
                    i.fa(:class="item.icon")
                  span.name(v-if="showSidebarDesktop") {{ item.name}}
                  span.icon.is-small.is-angle.left-85(:class="!showSidebarDesktop && !showSidebarMobile ? 'margin-right--4' : ''")
                    i.fa.fa-angle-down
                transition(name="fade-smooth")
                  .children(
                    v-show="item.showChildren"
                  )
                    ul.menu-list(:class="!showSidebarDesktop && !showSidebarMobile ? 'menu-list-hide' : ''")
                      li(v-for='(itemChildren, indexChildren) in item.children')
                        router-link.has-text-left.router-link(:to='itemChildren.path', :class="!showSidebarDesktop && !showSidebarMobile ? 'router-item' : ''", :key='itemChildren.key')
                          span.icon.is-small(v-if="!showSidebarDesktop && !showSidebarMobile", :title="itemChildren.name")
                            i.fa(:class="itemChildren.icon")
                          span.name(v-if="showSidebarDesktop") {{ itemChildren.name }}
                          template(v-if="itemChildren.key === 'vacaciones'")
                            .badge(v-if="datos.diasVacaciones", :title="datos.diasVacaciones + ' dias para gozar'")
                              span {{ datos.diasVacaciones }}
                          template(v-if="itemChildren.key === 'mis-documentos-firmar'")
                            .badge(v-if="documentosPorFirmar", :title="documentosPorFirmar + ' documentos sin cargar'")
                              span {{ documentosPorFirmar }}
                          template(v-if="itemChildren.key === 'mis-contratos'")
                            .badge(v-if="contratosPorFirmar", :title="contratosPorFirmar + ' contratos sin cargar'")
                              span {{ contratosPorFirmar }}
                          template(v-if="itemChildren.key === 'mis-cursos'")
                            .badge(v-if="cursosSinTerminar", :title="cursosSinTerminar + ' cursos sin terminar'")
                              span {{ cursosSinTerminar }}
                hr.margin-0(v-if="!showSidebarDesktop && !showSidebarMobile")



        .loading-short(v-else)
          span.icon
            i.fa.fa-circle-o-notch.fa-spin
          | Cargando el menu
          //- ()
      .menu-label-bgcolor.button-delegacion(@click="abrirDelegacion", v-if="(!(estoyReemplazando || estoySiendoReemplazado) && (perfilUsuario === 'jefe' || perfilUsuario === 'recursos humanos'))")
        span Definir Reemplazo
        i.fa.fa-plane
      .menu-label-bgcolor(v-if="isUserBirthday")
        span ¡Feliz cumpleaños!&nbsp;
        i.fa.fa-birthday-cake.ml-5s
      .delegaciones(v-if="(estoyReemplazando || estoySiendoReemplazado) && showSidebarMobile")
        delegaciones-mostrar-reemplazo(:isMobile="showSidebarMobile")
      div.menu-label-name(v-if="showSidebarDesktop || showSidebarMobile")
        span
          strong {{ datos.nombre }}
      div.menu-label-name.salir(v-if="showSidebarMobile", @click='logout')
        span
          strong
            template(v-if="isSaliendo")
              | Saliendo&nbsp;
              i.fa.fa-spinner.fa-spin
            template(v-else)
              | Salir
</template>

<script>
  import { apiGet } from '../util/general'
  import DelegacionesMostrarReemplazo from './c_delegaciones_mostrar_reemplazo'
  export default {
    name: 'sidebar',
    components: {
      DelegacionesMostrarReemplazo
    },
    data () {
      return {
        perfilUsuario    : localStorage.getItem('perfilVacaciones'),
        menu : [],
        isLoadingMenu    : false,
        datos: {
          diasVacaciones: 0,
          nombre: '',
          documentoSinCargar:0
        },
        show: false,
        empresa: process.env.EMPRESA,
        isSaliendo: false,
        pathFoto: '',
        codigoEmpleado: +localStorage.getItem('codigo')
      }
    },
    created () {
      this.fetchMenu()
      this.fetchInfoUsuario()
      this.fetchFotoUsuario()
      this.fetchDocumentosSinCargar()
      this.fetchContratosSinCargar()
      this.fetchCursosSinTerminar()
    },
    beforeDestroy () {
      this.isSaliendo = false
    },
    computed: {
      logo: () => {
        return '/static/logo_' + process.env.EMPRESA + '.png'
      },
      showSidebarDesktop () {
        return this.$store.getters.showSidebarDesktop
      },
      showSidebarMobile () {
        return this.$store.getters.showSidebarMobile
      },
      isUserBirthday () {
        return this.$store.getters.isUserBirthday
      },
      estoySiendoReemplazado () {
        return this.$store.getters.estoySiendoReemplazado
      },
      estoyReemplazando () {
        return this.$store.getters.estoyReemplazando
      },
      documentosPorFirmar () {
        return this.$store.getters.documentosPorFirmar
      },
      contratosPorFirmar () {
        return this.$store.getters.contratosPorFirmar
      },
      cursosSinTerminar () {
        return this.$store.getters.cursosSinTerminar
      }
    },
    methods: {
      abrirDelegacion () {
        this.$emit('delegacion')
      },
      logout () {
        localStorage.setItem('token', '')
        localStorage.setItem('perfilVacaciones', '')
        this.isSaliendo = true
        window.location.href = '/'
      },
      fetchCursosSinTerminar () {
        var vm = this
        apiGet(vm, '/curso/virtual/alumno/sin-terminar', {}, function (data) {
          vm.$store.dispatch('setCursosSinTerminar', data.cantidad)
        })
      },
      fetchDocumentosSinCargar () {
        var vm = this
        apiGet(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          if (data.lista.length > 0) {
            vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length)
          }
        })
      },
      fetchContratosSinCargar () {
        var vm = this
        apiGet(vm, '/contratos/obtener/mis-contratos', {}, function (data) {
          if (data.lista.length > 0) {
            vm.$store.dispatch('setContratosPorFirmar', data.lista.filter(a => !a.firmado).length)
          }
        })
      },
      fetchMenu () {
        var vm = this
        this.isLoadingMenu = true
        var obj = {
          perfilVacaciones : localStorage.getItem('perfilVacaciones'),
          username : localStorage.getItem('username')
        }

        apiGet(vm, '/usuario/menu', obj, function (data) {
          vm.menu = data.menu
        }, function (error) {
          alert('error: ' + error.message)
        }, function () {
          vm.isLoadingMenu = false
        })
      },
      fetchInfoUsuario () {
        var vm = this
        var obj = {
          codigo : localStorage.getItem('codigo')
        }
        apiGet(vm, '/vacaciones/empleado/diasdisponibles', obj, function (data) {
          vm.datos.diasVacaciones = data.count
          vm.datos.nombre = data.nombre
        }, function (error) {
          alert('error: ' + error.message)
        })
      },
      fetchFotoUsuario () {
        var vm = this
        var obj = {
          codigo : vm.codigoEmpleado
        }
        apiGet(vm, '/personal/fotoPerfil', obj, function (data) {
          vm.pathFoto = data.foto
        }, function (error) {
          alert('error: ' + error.message)
        }, function () {
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
   rgba(0, 0, 0, 0.3); /* Una sombra ligera para resaltar */
  .contenedor-sidebar
    >*
      transition all .3s
      width 100%
  .app-sidebar
    position: fixed;
    top: 45px;
    left: 0;
    bottom: 0;
    padding: 20px 0 0px;
    width: 180px;
    min-width: 45px;
    max-height: 100vh;
    height: calc(100% - 45px);
    z-index: 1024 - 1;
    background: #FFF;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
    overflow-y: hidden;
    overflow-x: hidden;
    font-size 14px
    display flex
    flex-direction column

    .icon
      vertical-align: baseline;
      margin-right 5px

      &.is-angle
        position: absolute;
        right: 10px;
        top: 10px;
        transition: transform .377s ease;

    .menu-label
      padding-left: 5px;

    .menu-label-name
      flex 0
      padding 0px 5px
      font-weight: 100;
      font-size 12px
      margin-bottom 5px

    .menu-label-bgcolor
      background-color: #da07bf
      color: #fff
      padding-top: 10px;
      padding-bottom: 10px;
      display flex
      justify-content: center
      align-items: center
      margin-bottom 2px
      span
        line-height: 18px
      .fa
        font-size: 18px

    .button-delegacion
      cursor pointer
      width 90%
      border-radius: 5px
      margin auto
      margin-bottom 5px
      padding-left 10px
      padding-right: 10px

      &:hover
        background-color #9a0687

      span
        margin-right 5px
    .menu-list
      li a + ul
        margin: 0 10px 0 15px;
      flex 1

    .router-link
      border-radius 0px
      transition 0.2s padding ease
      display flex

      .name
        flex 1

      .badge
        color #565cde

    .router-link-exact-active
      background-color: #565cde
      color: #fff
      padding-left 15px
      .badge
        color #fff

    .info-permiso
      .title
        display flex
        align-items center
        background-color #565cde
        color #ffffff
        font-size 16px
        padding 5px
        text-align left
        margin-bottom 0
        .icon
         margin-left 5px
      .list
        background-color #dbdbdb
        text-align left
        padding-left 10px
        display flex
        span
          font-size 12px

        .name
          flex 1

        .edit
          .icon
            cursor pointer
            &:hover
              color #565cde

    .menu-list
      .is-angle
        font-size: 20px;

      a.open
        .is-angle
          transform: rotate(180deg);

    .children
      overflow-y hidden
      .menu-list
        margin: 0;

    .tag
      background-color: #565cde
      color white
      margin-left 5px
      font-size: 7px;

  .hide-sidebar
    width: 0px;

  .router-item
    height         : 42px;
    border-left    : 0 !important
    display        : flex;
    justify-content: center;
    align-items    : center;

  .menu-list-hide
    border-left : 0
    padding-left: 0
  .modal {
    display: none;
    position: fixed;
    z-index: 99;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .modal-content {
    color: #fefefe;
    margin: 30% auto;
    padding: 20px;
    width: 80%;
  }

  .modal-header h4 {
    margin-top: 0;
  }

  .loading {
    border: 16px solid #f3f3f3;
    border-top: 16px solid #3498db;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 2s linear infinite;
    margin: auto;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @media (max-width: 820px)
    .app-sidebar
      display none;

    .is-mobile
      background-color #fff
      color #333
      height 100dvh
      max-height: calc(100dvh - 65px);/* Resta la altura de la barra inferior */
      min-height: calc(100dvh - 65px);/* Resta la altura de la barra inferior */
      padding-top 12px
      width 250px
      position fixed
      top 0
      left 0px
      display flex
      flex-direction column
      transition all 0.3s ease-in-out
      .salir
        margin-bottom: 0px
        padding-top: 10px
        padding-bottom: 10px
        background-color red
        font-size: 14px
        strong
          color: #fff
</style>



// WEBPACK FOOTER //
// Sidebar.vue?2b2201a8